import { Link } from "@tanstack/react-router";
import { Building2Icon, HistoryIcon, WrenchIcon, type LucideIcon } from "lucide-react";

import { cn } from "../lib/utils";

export type ShellNavigationItem = "tools" | "workspace" | "audit-trail";

type NavigationItem = {
  id: ShellNavigationItem;
  label: string;
  to: "/" | "/workspace" | "/audit-trail";
  icon: LucideIcon;
};

const navigationItems: NavigationItem[] = [
  {
    id: "tools",
    label: "Tools",
    to: "/",
    icon: WrenchIcon,
  },
  {
    id: "workspace",
    label: "Workspace",
    to: "/workspace",
    icon: Building2Icon,
  },
  {
    id: "audit-trail",
    label: "Audit Trail",
    to: "/audit-trail",
    icon: HistoryIcon,
  },
];

export function PrimaryNavigation({
  activeItem,
  adminView,
  organizationId,
}: {
  activeItem: ShellNavigationItem | null;
  adminView: boolean;
  organizationId: string | undefined;
}) {
  const visibleItems = adminView
    ? navigationItems
    : navigationItems.filter((item) => item.id === "tools");

  return (
    <nav aria-label="Primary navigation" className="shell-primary-navigation">
      {visibleItems.map((item) => {
        const Icon = item.icon;
        const isActive = activeItem === item.id;

        return (
          <Link
            aria-current={isActive ? "page" : undefined}
            className={cn("shell-navigation-link", isActive && "shell-navigation-link-active")}
            key={item.id}
            search={{ org: organizationId }}
            to={item.to}
          >
            <Icon aria-hidden="true" />
            <span>{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
